export default "__VITE_ASSET__BxPb460x__"